/* eslint-disable */
// [ULTURE] Banderas del selector de idioma (SVG propio: los emoji de bandera no se ven en Windows).
// es España · en Reino Unido · it Italia · fr Francia · nl Países Bajos · ar Arabia Saudí · zh China
import React from 'react';

const FLAGS = {
  es: () => (<><rect width="30" height="20" fill="#AA151B" /><rect y="5" width="30" height="10" fill="#F1BF00" /></>),
  it: () => (<><rect width="30" height="20" fill="#fff" /><rect width="10" height="20" fill="#009246" /><rect x="20" width="10" height="20" fill="#CE2B37" /></>),
  fr: () => (<><rect width="30" height="20" fill="#fff" /><rect width="10" height="20" fill="#0055A4" /><rect x="20" width="10" height="20" fill="#EF4135" /></>),
  nl: () => (<><rect width="30" height="20" fill="#fff" /><rect width="30" height="6.67" fill="#AE1C28" /><rect y="13.33" width="30" height="6.67" fill="#21468B" /></>),
  en: () => (
    <>
      <rect width="30" height="20" fill="#012169" />
      <path d="M0 0 30 20M30 0 0 20" stroke="#fff" strokeWidth="4" />
      <path d="M0 0 30 20M30 0 0 20" stroke="#C8102E" strokeWidth="1.6" />
      <path d="M15 0v20M0 10h30" stroke="#fff" strokeWidth="6" />
      <path d="M15 0v20M0 10h30" stroke="#C8102E" strokeWidth="3.4" />
    </>
  ),
  ar: () => (
    <>
      <rect width="30" height="20" fill="#006C35" />
      <path d="M8 7.2c1.2-1 2.2.6 3.4-.4s2.1.5 3.3-.4 2.2.6 3.4-.4 2.1.5 3.3-.4" fill="none" stroke="#fff" strokeWidth="1.1" strokeLinecap="round" />
      <path d="M8.5 9.6c1.3-.8 2.6.4 3.9-.3s2.6.4 3.9-.3 2.6.4 3.9-.3" fill="none" stroke="#fff" strokeWidth="0.9" strokeLinecap="round" />
      <path d="M8 13.4h13.2" stroke="#fff" strokeWidth="1.1" strokeLinecap="round" />
      <path d="M20.2 12.4v2" stroke="#fff" strokeWidth="1" strokeLinecap="round" />
    </>
  ),
  zh: () => (
    <>
      <rect width="30" height="20" fill="#EE1C25" />
      <path d="M5 2.2l.98 3.02h3.17l-2.57 1.86.98 3.02L5 8.24 2.44 10.1l.98-3.02L.85 5.22h3.17z" fill="#FFFF00" />
      <circle cx="10.2" cy="2.4" r=".95" fill="#FFFF00" /><circle cx="12" cy="4.4" r=".95" fill="#FFFF00" />
      <circle cx="12" cy="7.2" r=".95" fill="#FFFF00" /><circle cx="10.2" cy="9.2" r=".95" fill="#FFFF00" />
    </>
  ),
};

export default function Flag({ code, size = 20 }) {
  const Draw = FLAGS[code];
  if (!Draw) return null;
  const h = Math.round(size * 2 / 3);
  return (
    <svg width={size} height={h} viewBox="0 0 30 20" aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid slice"
      style={{ display: 'block', flexShrink: 0, borderRadius: Math.max(2, Math.round(size / 7)), boxShadow: '0 0 0 0.5px rgba(19,49,74,0.22)', overflow: 'hidden' }}>
      <Draw />
    </svg>
  );
}
